module.exports = __webpack_public_path__ + "img/player2.b2c35749.png";